<template>
  <div>
    <IndexNavbar />
    <main>
      <div
        class="relative pt-16 pb-32 flex content-center items-center justify-center min-h-screen-75"
      >
        <div
          class="absolute top-0 w-full h-full bg-center bg-cover"
          style="
            background-image: url('https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1267&q=80');
          "
        >
          <span
            id="blackOverlay"
            class="w-full h-full absolute opacity-75 bg-black"
          ></span>
        </div>
        <div class="container relative mx-auto">
          <div class="items-center flex flex-wrap">
            <div class="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">
              <div class="pr-12">
                <h1 class="text-white font-semibold text-5xl">
                  Your story starts with us.
                </h1>
                <p class="mt-4 text-lg text-blueGray-200">
                  At AmeiseTech, our products are designed to help organizations measure, manage, and improve performance across sustainability, ESG, and digital operations. Built on modern technology and industry best practices, our solutions empower businesses to make informed decisions, ensure compliance, and achieve long-term resilience.
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- <div
          class="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden h-70-px"
          style="transform: translateZ(0);"
        >
          <svg
            class="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              class="text-blueGray-200 fill-current"
              points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div> -->
      </div>

       <section class="pb-20 bg-blueGray-200 -mt-24">
                <div class="container mx-auto px-4">
                    <div class="flex flex-wrap">
                       
                    </div>

                    <div class="flex flex-wrap items-center mt-32" id="ai-implementation">
                       
                       <div class="w-full md:w-4/12 px-4 mr-auto ml-auto">
                            <div style="background-color: #a89f1e;"
                                class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg bg-emerald-500">
                                <img alt="..."
                                    src="@/assets/img/EALMS.png"
                                    class="w-full align-middle rounded-t-lg" />
                                <blockquote class="relative p-8 mb-4">
                                    <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 583 95" class="absolute left-0 w-full block h-95-px -top-94-px">
                                        <polygon style="    color: rgb(168 159 30);" points="-30,95 583,95 583,65" class="text-emerald-500 fill-current">
                                        </polygon>
                                    </svg>

                                    <ul>

                                        <h4 class="text-xl font-bold text-white">
                                            Employee Attendance and Leave Management System (EALMS)
                                        </h4>
                                        <span style="color: white;">we provide a smart and intuitive EALMS solution that helps organizations manage their employee attendance and leave efficiently and effectively</span>
                                        <li class="text-md font-light mt-2 text-white">
                                            <i
                                                class="fas fa-dot-circle text-green-500 mr-2"></i>
                                                Automate repetitive tasks such as attendance tracking, leave requests, and approvals
                                        </li>
                                        <li class="text-md font-light mt-2 text-white"> <i
                                                class="fas fa-dot-circle text-green-500 mr-2"></i>
                                                Real-time attendance tracking and reporting.
                                        </li>
                                        <li class="text-md font-light mt-2 text-white"> <i
                                                class="fas fa-dot-circle text-green-500 mr-2"></i>
                                                Transparent and user-friendly processes.
                                        </li>
                                        <li class="text-md font-light mt-2 text-white"> <i
                                                class="fas fa-dot-circle text-green-500 mr-2"></i>
                                                accurate leave balance calculations and reporting.
                                        </li>
                                        <li class="text-md font-light mt-2 text-white"> <i
                                                class="fas fa-dot-circle text-green-500 mr-2"></i>
                                                accessible via web and mobile devices.
                                        </li>
                                        <li class="text-md font-light mt-2 text-white"> <i
                                                class="fas fa-dot-circle text-green-500 mr-2"></i>
                                                Flexible solution for startups, SMEs, and enterprises.
                                        </li>
                                    </ul>
                                </blockquote>
                            </div>
                        </div>
                        <div class="w-full md:w-4/12 px-4 mr-auto ml-auto">
                            <div style="background-color: #e85c4a;"
                                class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg bg-emerald-500">
                                <img alt="..."
                                    src="@/assets/img/project-estimater.png"
                                    class="w-full align-middle rounded-t-lg" />
                                <blockquote class="relative p-8 mb-4">
                                    <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 583 95" class="absolute left-0 w-full block h-95-px -top-94-px">
                                        <polygon style="color: #e85c4a;" points="-30,95 583,95 583,65" class="text-emerald-500 fill-current">
                                        </polygon>
                                    </svg>

                                    <ul>

                                        <h4 class="text-xl font-bold text-white">
                                            Project Estimator 
                                        </h4>
                                        <span style="color: white;">Project Estimator is a smart and intuitive solution that helps organizations estimate project costs, resources, and timelines with accuracy and efficiency.</span>
                                         <li class="text-md font-light mt-2 text-white">
                                           <i class="fas fa-paper-plane text-green-500 mr-2"></i>
                                            Accurate cost estimation using historical data and industry benchmarks
                                        </li>
                                        <li class="text-md font-light mt-2 text-white"> <i
                                                class="fas fa-paper-plane text-green-500 mr-2"></i>
                                            Resource allocation and management for optimal project delivery
                                        </li>
                                        <li class="text-md font-light mt-2 text-white"> <i
                                                class="fas fa-paper-plane text-green-500 mr-2"></i>
                                            Timeline forecasting and scheduling for better project planning
                                        </li>
                                        <li class="text-md font-light mt-2 text-white"> <i
                                                class="fas fa-paper-plane text-green-500 mr-2"></i>
                                            Collaboration tools for team communication and coordination
                                        </li>
                                        <li class="text-md font-light mt-2 text-white"> <i
                                                class="fas fa-paper-plane text-green-500 mr-2"></i>
                                            Flexible solution for startups, SMEs, and enterprises.
                                        </li>
                                    </ul>
                                </blockquote>
                            </div>
                        </div>
                        <div class="w-full md:w-4/12 px-4 mr-auto ml-auto">
                            <div
                                class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg bg-emerald-500">
                                <img alt="..."
                                    src="@/assets/img/Air-offset.png"
                                    class="w-full align-middle rounded-t-lg" />
                                <blockquote class="relative p-8 mb-4">
                                    <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 583 95" class="absolute left-0 w-full block h-95-px -top-94-px">
                                        <polygon points="-30,95 583,95 583,65" class="text-emerald-500 fill-current">
                                        </polygon>
                                    </svg>

                                    <ul>

                                        <h4 class="text-xl font-bold text-white">
                                            Air Travel emission calculator
                                        </h4>
                                        <li class="text-md font-light mt-2 text-white">
                                            <i
                                                class="fas fa-dot-circle text-green-500 mr-2"></i>
                                                Accurate carbon footprint calculations for air travel
                                        </li>
                                        <li class="text-md font-light mt-2 text-white"> <i
                                                class="fas fa-dot-circle text-green-500 mr-2"></i>
                                                User-friendly interface for easy navigation
                                        </li>
                                        <li class="text-md font-light mt-2 text-white"> <i
                                                class="fas fa-dot-circle text-green-500 mr-2"></i>
                                                Emission reduction strategies for airlines and travelers
                                        </li>
                                        <li class="text-md font-light mt-2 text-white"> <i
                                                class="fas fa-dot-circle text-green-500 mr-2"></i>
                                                Integration with other sustainability tools and platforms
                                        </li>
                                        <li class="text-md font-light mt-2 text-white"> <i
                                                class="fas fa-dot-circle text-green-500 mr-2"></i>Flexible solution
                                            for startups, SMEs, and enterprises.
                                        </li>
                                    </ul>
                                </blockquote>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </section>
      
    </main>
    <footer-component />
  </div>
</template>
<script>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";

import team1 from "@/assets/img/team-1-800x800.jpg";
import team2 from "@/assets/img/team-2-800x800.jpg";
import team3 from "@/assets/img/team-3-800x800.jpg";
import team4 from "@/assets/img/team-4-470x470.png";

export default {
  data() {
    return {
      team1,
      team2,
      team3,
      team4,
    };
  },
  components: {
    IndexNavbar,
    FooterComponent,
  },
};
</script>
